import type { BookingPreference } from '../../domain/types'
import type { BookingPreferencesAPIResponse } from '../types'

export function bookingPreferencesMapper(apiResponse: BookingPreferencesAPIResponse): BookingPreference[] {
  if (!apiResponse.preferences)
    return []

  return apiResponse.preferences
    .filter(preference => Boolean(preference.id))
    .map(preference => ({
      id: preference.id as string,
      text: preference.text ?? '',
      type: preference.type ?? 'Standard',
      isSelected: preference.isChecked === true,
      customerInput: preference.customerInput ?? '',
    }))
}
